<div class="s09-run">
  <header class="s09-top">
    <button type="button" class="s09-back" (click)="back.emit()" title="Back to the designer">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"></path></svg>
    </button>
    <span class="s09-title">Run workflow</span>
    <span class="s09-chip" [class.status-active]="liveAllowed" [class.status-draft]="!liveAllowed">{{ workflowStatus || 'DRAFT' }}</span>
    <button type="button" class="s09-icon-btn s09-run-refresh" [disabled]="refreshing || running"
      (click)="refresh()" title="Refresh status" aria-label="Refresh status">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
        [class.s09-spin]="refreshing">
        <path d="M21 12a9 9 0 1 1-2.6-6.3"></path>
        <path d="M21 3v6h-6"></path>
      </svg>
    </button>
  </header>

  <div class="s09-run-body">
    <section class="s09-run-patients">
      <div class="s09-field">
        <label>Trigger status codes</label>
        <div class="s09-chip-row">
          <span class="s09-code-chip" *ngFor="let code of codes">{{ code }}</span>
          <span *ngIf="!codes.length" class="s09-field-hint">No status codes on the saved trigger.</span>
        </div>
      </div>

      <div *ngIf="loading" class="s09-field-hint">Loading patients…</div>
      <div *ngIf="notice && !run" class="s09-field-hint">{{ notice }}</div>

      <div class="s09-run-table" *ngIf="patients.length">
        <button type="button" class="s09-run-row" *ngFor="let p of patients"
          [class.on]="selectedId===p.du_patient_id"
          (click)="selectPatient(p.du_patient_id)">
          <span><b>{{ p.du_patient_id }}</b><small>{{ p.hub_patient_id || 'No hub id' }}</small></span>
          <span class="s09-code-chip">{{ p.status_reason_code }}</span>
          <span>{{ p.patient_status }}</span>
          <span>{{ p.status_group }}</span>
          <span class="s09-run-place" *ngIf="placeFor(p.du_patient_id)">Running</span>
          <span>{{ p.last_status_date }}</span>
        </button>
      </div>

      <div class="s09-run-actions">
        <button type="button" class="s09-btn primary" [disabled]="!selectedId || running || !!selectedActive" (click)="start('TEST')">Test run</button>
        <button type="button" class="s09-btn active-green" [disabled]="!selectedId || running || !liveAllowed || !!selectedActive"
          [title]="selectedActive ? 'This patient already has a run in progress' : (liveAllowed ? 'Run the workflow on this patient' : 'Activate the workflow before a live run')"
          (click)="start('LIVE')">Live run</button>
      </div>
    </section>

    <section class="s09-run-log" *ngIf="run">
      <div class="s09-run-log-h">
        <strong>Run {{ run.wf_run_id }}</strong>
        <span class="s09-chip">{{ run.mode }}</span>
        <span class="s09-chip" [class.status-active]="run.status==='SUCCESS'" [class.status-draft]="run.status==='WAITING' || run.status==='FAILED'">{{ run.status }}</span>
        <button type="button" class="s09-icon-btn s09-run-refresh" [disabled]="refreshing || running"
          (click)="refresh()" title="Refresh status" aria-label="Refresh status">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            [class.s09-spin]="refreshing">
            <path d="M21 12a9 9 0 1 1-2.6-6.3"></path>
            <path d="M21 3v6h-6"></path>
          </svg>
        </button>
      </div>
      <p class="s09-field-hint" *ngIf="selectedActive">This workflow is already running for this patient. {{ run?.place || selectedActive.place }}</p>
      <p class="s09-field-hint" *ngIf="run.message">{{ run.message }}</p>
      <p class="s09-field-hint" *ngIf="waitingDelay && run.mode==='LIVE'">This live wait stays here until {{ run.due_at }}.</p>
      <p class="s09-field-hint" *ngIf="waitingApproval">The email is waiting. Open the case in Case Management and choose Approve or Reject on the task. The email is sent only after approval.</p>
      <p class="s09-field-hint" *ngIf="waitingFrm && run.mode==='LIVE'">Open My Tasks or the case Tasks tab and choose Escalate or Wait on Waiting for FRM Action.</p>

      <div class="s09-run-wait" *ngIf="waitingFrm">
        <div class="s09-run-wait-banner">Waiting for FRM Action</div>
        <label>FRM Action</label>
        <p class="s09-field-hint">Escalate the case, or enter how many days to wait before the next step.</p>
        <div class="s09-run-actions">
          <button type="button" class="s09-btn" [disabled]="running" (click)="answer('escalate')">Escalate</button>
          <input type="number" min="1" placeholder="Days" [(ngModel)]="frmDays" />
          <button type="button" class="s09-btn primary" [disabled]="running" (click)="answer('wait')">Wait</button>
        </div>
      </div>
      <div class="s09-run-wait" *ngIf="waitingDelay && run.mode==='TEST'">
        <button type="button" class="s09-btn primary" [disabled]="running" (click)="answer('continue')">Continue</button>
      </div>

      <div class="s09-log-row" *ngFor="let step of run.steps || []; let last = last" [class.on]="last">
        <span>{{ step.status }}</span>
        <span>{{ stepLabel(step.step_type_id) }}</span>
        <span>{{ step.message || '—' }}</span>
      </div>
    </section>
  </div>
</div>
